// =============================================================================
// COMMON API PARAMETERS
// =============================================================================
import axios from "axios";
const axiosClient = axios.create({
  baseURL: ''
});
axiosClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return error.response;
  }
);

export default axiosClient;
